import React from 'react';

const LoadingIndicator = () => <div className="spinner" />;

export default LoadingIndicator;
